import * as Yup from 'yup';
import i18n from 'i18n';

const schema = Yup.object().shape({
  Name: Yup.string()
    .required(() => i18n.t('common:validation.fieldRequired')),

  Phone: Yup.string()
    .required(() => i18n.t('common:validation.fieldRequired')),

  StreetAddress: Yup.string()
    .required(() => i18n.t('common:validation.fieldRequired')),

  Zip: Yup.string()
    .required(() => i18n.t('common:validation.fieldRequired')),

  Number: Yup.number().typeError(() => i18n.t('common:validation.invalidNumber')),

  District: Yup.string()
    .required(() => i18n.t('common:validation.fieldRequired')),

  City: Yup.string()
    .required(() => i18n.t('common:validation.fieldRequired')),

  State: Yup.string()
    .required(() => i18n.t('common:validation.fieldRequired')),
});

export default schema;
